import { useState } from 'react';

export function NewTemplateTabs({ generate, import: importForm }: { generate: React.ReactNode; import: React.ReactNode }) {
  const [tab, setTab] = useState<'generate' | 'import'>('generate');
  const cls = (t: string) => `rounded-md px-3 py-1.5 text-sm ${tab === t ? 'bg-[var(--ff-primary)] text-white' : 'bg-white ring-1 ring-border'}`;
  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <button className={cls('generate')} onClick={() => setTab('generate')}>
          Generate with AI
        </button>
        <button className={cls('import')} onClick={() => setTab('import')}>
          Import HTML / zip
        </button>
      </div>
      {tab === 'generate' ? generate : importForm}
    </div>
  );
}
